import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { default as classNames, default as cn } from 'classnames';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Configurator from '../../components/HorseTabs/Configurator/Configurator';
import HorseStats from '../../components/HorseTabs/HorseStats/HorseStats';
import RaceStats from '../../components/HorseTabs/RaceStats/RaceStats';
import { useHorses } from '../../hooks/stable';
import { useAppDispatch, useAppSelector } from '../../store/reducers';
import { setStableIframeHeight } from '../../store/reducers/IFrame/iFrameSlice';
import { getHorse } from '../../store/reducers/Stable/slice';
import { selectHorseById } from '../../store/selectors/stableSelectors';
import * as log from '../../utils/log';
import SingleView from '../SingleView/SingleView';
import HorseDetails from './HorseDetails/HorseDetails';
import styles from './HorseView.module.scss';
export var HORSE_TAB_KEYS;
(function (HORSE_TAB_KEYS) {
    HORSE_TAB_KEYS["HORSE_STATS"] = "HORSE_STATS";
    HORSE_TAB_KEYS["RACE_STATS"] = "RACE_STATS";
    HORSE_TAB_KEYS["CONFIGURATOR"] = "CONFIGURATOR";
})(HORSE_TAB_KEYS || (HORSE_TAB_KEYS = {}));
const HorseView = () => {
    const params = useParams();
    const pathname = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(HORSE_TAB_KEYS.HORSE_STATS);
    const activeStableButton = useAppSelector((state) => state.stableTab.activeStableButton);
    const horse = useAppSelector((state) => selectHorseById(state, params.id));
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (horse) {
            dispatch(getHorse(horse.static.asset));
        }
    }, [horse, dispatch]);
    useHorses();
    const onClick = useCallback((value) => {
        setActiveTab(value);
    }, [setActiveTab]);
    const buttons = useMemo(() => [
        { name: t('race'), disabled: true },
        { name: t('details'), disabled: false }
        // { name: t('sell'), disabled: true }
    ], [t]);
    const StableElementRef = useRef(null);
    const horseTabs = useMemo(() => [
        {
            label: t('horse_stats'),
            value: HORSE_TAB_KEYS.HORSE_STATS
        },
        {
            label: t('race_stats'),
            value: HORSE_TAB_KEYS.RACE_STATS
        },
        {
            label: t('configurator'),
            value: HORSE_TAB_KEYS.CONFIGURATOR
        }
    ], [t]);
    const renderView = useMemo(() => ({
        [HORSE_TAB_KEYS.HORSE_STATS]: _jsx(HorseStats, { horse: horse }),
        [HORSE_TAB_KEYS.RACE_STATS]: _jsx(RaceStats, { horse: horse }),
        [HORSE_TAB_KEYS.CONFIGURATOR]: _jsx(Configurator, { horse: horse })
    }), [horse]);
    const handleResize = () => {
        var _a, _b;
        log.debug('3d scene scroll Height', (_a = StableElementRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight);
        dispatch(setStableIframeHeight((_b = StableElementRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight));
    };
    useEffect(() => {
        handleResize();
    }, []);
    useEffect(() => {
        handleResize();
    }, [pathname]);
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [pathname, dispatch]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ ref: StableElementRef, className: classNames(styles.element, 'd-flex flex-column justify-content-between w-100') }, { children: [_jsx(SingleView, { horse: horse || null, onClick: onClick, activeTab: activeTab, navigateTo: () => navigate(-1), tabs: horseTabs, className: styles.wrapper, buttons: buttons }), _jsx("div", Object.assign({ className: classNames(styles.box, styles.wrapperBG) }, { children: renderView[activeTab] }))] })), _jsx("div", Object.assign({ className: cn(styles.box, styles.detailsHeight, activeStableButton && styles['showWidth']) }, { children: _jsx(HorseDetails, { className: cn(styles.details, activeStableButton && styles['isActive']) }) }))] }));
};
export default HorseView;
